import React from 'react'
import Ryzyka from '../../common/pages/Ryzyka.jsx'

const S2_Ryzyka = (props) => {
    return (<Ryzyka data={props}/>)
}

export default S2_Ryzyka

